import { cn } from '../../lib/cn';
import {
  FOLDER_TEMPLATE_CHOICES,
  folderNamesForTemplate,
  type FolderTemplateChoice,
} from '../../lib/folderTemplates';

interface Props<T extends string> {
  value: T;
  onChange: (choice: T) => void;
  includeNone?: boolean;
  choices?: readonly { slug: T; label: string }[];
  preview?: string;
}

export function FolderTemplatePicker<T extends string>({ value, onChange, includeNone = true, choices, preview }: Props<T>) {
  const resolved = choices ?? (includeNone
    ? FOLDER_TEMPLATE_CHOICES
    : FOLDER_TEMPLATE_CHOICES.filter((c) => c.slug !== 'none'));
  const staticPreview = choices
    ? (preview ?? '')
    : folderNamesForTemplate(value as FolderTemplateChoice).join(', ');
  const previewText = choices ? (preview ?? '') : staticPreview;

  return (
    <div>
      <label className="block text-sm font-medium text-cime-text-primary mb-1.5">
        Arborescence
      </label>
      <div className={cn('grid gap-1.5', resolved.length <= 3 ? 'grid-cols-3' : 'grid-cols-2')}>
        {resolved.map((c) => (
          <button
            key={c.slug}
            type="button"
            onClick={() => onChange(c.slug as T)}
            className={cn(
              'px-2 py-2 text-xs rounded-md border transition',
              value === c.slug
                ? 'bg-cime-primary text-white border-cime-primary'
                : 'bg-white text-cime-text-primary border-neutral-200 hover:border-cime-primary/40',
            )}
          >
            {c.label}
          </button>
        ))}
      </div>
      <p className="mt-1.5 text-[11px] text-cime-text-muted">
        {value === 'none'
          ? 'Aucun sous-dossier. Vous pourrez en créer à la main, ou appliquer une arborescence plus tard si le dossier est encore vide.'
          : previewText
            ? `Sous-dossiers à la racine (modifiables ensuite) : ${previewText}.`
            : 'Arborescence choisie.'}
      </p>
    </div>
  );
}
